import React from 'react';
import { useIntl } from 'react-intl';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import Button from '@ts-core/components/Button';

interface ScoreFormProps {
  score?: string;
  onScoreChange: (score: string) => void;

  mode: 'score' | 'full';

  isSubmitting?: boolean;
  onSubmit?: () => void;
}

const ScoreForm = (props: ScoreFormProps) => {
  const { score, onScoreChange, mode, isSubmitting, onSubmit } = props;
  const intl = useIntl();

  return (
    <Stack direction="row" spacing={2}>
      <TextField
        required={mode === 'score'}
        size="small"
        sx={{ maxWidth: 280 }}
        label="Puntaje"
        value={score}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onScoreChange(event.target.value as string)}
      />
      {mode === 'score' && (
        <Button loading={isSubmitting} onClick={onSubmit} variant="text" disabled={!score}>
          {intl.formatMessage({ id: 'button.save.title' })}
        </Button>
      )}
    </Stack>
  );
};

export default ScoreForm;
